import en from './en.json';
import ar from './ar.json';

const lookup = (tree, path) => path.split('.').reduce(
  (node, key) => (node && typeof node === 'object' ? node[key] : undefined),
  tree,
);

const fill = (text, vars) => (vars
  ? String(text).replace(/\{(\w+)\}/g, (match, name) => (vars[name] === undefined ? match : String(vars[name])))
  : text);

/**
 * {en, ar} for an i18n key, with {placeholders} filled, for `t()` from
 * LanguageContext. The strings live in en.json / ar.json; a key missing in
 * Arabic falls back to English, a missing key shows the key.
 */
export const pair = (path, vars) => {
  const english = lookup(en, path);
  const arabic = lookup(ar, path);
  const base = typeof english === 'string' ? english : path;
  return {
    en: fill(base, vars),
    ar: fill(typeof arabic === 'string' ? arabic : base, vars),
  };
};

export default pair;
